import { Link } from 'react-router-dom';
import { mangaList } from '@/mocks/manga';

export default function RankingSection() {
  const topManga = [...mangaList]
    .sort((a, b) => b.views - a.views)
    .slice(0, 5);

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            热门排行
          </h2>
          <p className="text-sm text-foreground-600 mt-2">
            最受读者欢迎的韩国漫画，人气最高的作品都在这里
          </p>
        </div>

        <div className="space-y-4">
          {topManga.map((manga, index) => (
            <Link
              key={manga.id}
              to={`/manga/${manga.slug}`}
              className="flex items-center gap-4 md:gap-6 p-4 rounded-xl bg-background-50 hover:bg-primary-50/50 transition-colors group no-underline"
            >
              <div className={`w-10 h-10 flex items-center justify-center rounded-full text-lg font-heading font-bold shrink-0 ${
                index === 0
                  ? 'bg-accent-500 text-white'
                  : index === 1
                  ? 'bg-secondary-500 text-white'
                  : index === 2
                  ? 'bg-primary-300 text-white'
                  : 'bg-background-200 text-foreground-600'
              }`}>
                {index + 1}
              </div>

              <div className="w-16 h-20 md:w-20 md:h-28 rounded-lg overflow-hidden bg-background-100 shrink-0">
                <img
                  src={manga.coverImage}
                  alt={`${manga.title} - 韩漫免费漫画`}
                  title={`${manga.title} - 热门韩国漫画`}
                  className="w-full h-full object-cover object-top"
                />
              </div>

              <div className="flex-1 min-w-0">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1">
                  {manga.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-1">{manga.author} · {manga.category}</p>
                <p className="text-xs text-foreground-400 mt-1 line-clamp-2 hidden md:block">
                  {manga.description.slice(0, 60)}...
                </p>
              </div>

              <div className="text-right shrink-0">
                <div className="flex items-center gap-1 text-accent-500">
                  <span className="w-3.5 h-3.5 flex items-center justify-center">
                    <i className="ri-star-fill text-xs"></i>
                  </span>
                  <span className="text-sm font-semibold">{manga.rating}</span>
                </div>
                <p className="text-xs text-foreground-400 mt-1">
                  {(manga.views / 10000).toFixed(0)}万阅读
                </p>
                <span className={`inline-block mt-1.5 px-2 py-0.5 text-xs rounded-full ${
                  manga.status === '连载中'
                    ? 'bg-accent-100 text-accent-700'
                    : 'bg-secondary-100 text-secondary-700'
                }`}>
                  {manga.status}
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}